import {memo, useMemo} from 'react';
import {Box, Typography} from '@mui/material';
import {formatAmountWithParen} from '@/utils/dataUtils';

export type PlFsReadonlyAmountProps = {
    value: number;
    fontWeight?: number | string;
};

/**
 * Lightweight MoneyField-equivalent for read-only PL FS cells.
 * Matches MoneyField showCents + accounting parentheses without TextField overhead.
 */
export const PlFsReadonlyAmount = memo(function PlFsReadonlyAmount({
    value,
    fontWeight,
}: PlFsReadonlyAmountProps) {
    const text = useMemo(() => formatAmountWithParen(value || 0), [value]);
    return (
        <Box sx={{
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            minWidth: 0,
        }}>
            <Typography
                variant="body2"
                component="span"
                sx={{
                    fontSize: 14,
                    lineHeight: 1.43,
                    textAlign: 'center',
                    fontWeight: fontWeight,
                    fontVariantNumeric: 'tabular-nums',
                    width: '100%',
                }}
            >
                {text}
            </Typography>
        </Box>
    );
});
